import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4a1240f7")

_pushScopeId("data-v-4a1240f7")
const _hoisted_1 = {
  "data-testid": "booking-v4-protection-packing-summary",
  class: "flex flex-col gap-3 mb-2"
}
const _hoisted_2 = { class: "flex flex-col gap-1" }
const _hoisted_3 = {
  for: "protection-packing-checkbox-proteksi",
  class: "text-14px text-black-lp-100 font-normal"
}
const _hoisted_4 = {
  key: 0,
  "data-testid": "txn-booking-label-proteksi-discount"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_6 = {
  key: 1,
  class: "px-2 py-1 mt-2 bg-blue-lp-600 w-full rounded-lg flex-col justify-center items-start gap-1 inline-flex"
}
const _hoisted_7 = { class: "justify-start items-start gap-1 inline-flex w-full text-xs text-blue-lp-700" }
const _hoisted_8 = { class: "space-x-1 py-0.5" }
const _hoisted_9 = { class: "font-medium font-montserrat" }
const _hoisted_10 = { class: "font-bold whitespace-nowrap" }
const _hoisted_11 = { class: "flex flex-col gap-1" }
const _hoisted_12 = { class: "text-xs text-black-lp-300 font-semibold text-left" }
const _hoisted_13 = /*#__PURE__*/_createVNode("hr", { class: "border-dashed" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (!_ctx.hiddenInsurance)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["flex flex-row items-center gap-x-2 mt-2", {
          'protection-disabled':
            _ctx.protectionPacking.protectionDisabled || _ctx.disabledInsurance
        }]
          }, [
            _createVNode(_component_Checkbox, {
              id: "protection-packing-checkbox-proteksi",
              class: "protection-packing-checkbox",
              binary: true,
              modelValue: _ctx.protectionPacking.protectionChecked,
              "data-testid": "txn-booking-checkbox-proteksi",
              disabled: _ctx.protectionPacking.protectionDisabled || _ctx.disabledInsurance,
              disabledBackground: 
            _ctx.protectionPacking.protectionDisabled || _ctx.disabledInsurance
          ,
              "onUpdate:modelValue": _ctx.onToggleProtection
            }, null, 8, ["modelValue", "disabled", "disabledBackground", "onUpdate:modelValue"]),
            _createVNode("label", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.protectionLabelDisplay) + " ", 1),
              (_ctx.agentDiscountCommission && _ctx.showAgentDiscount)
                ? (_openBlock(), _createBlock("span", _hoisted_4, [
                    _createTextVNode(" (" + _toDisplayString(_ctx.$t("bookingV4.protection.agentDiscount")) + " ", 1),
                    _createVNode("b", null, _toDisplayString(_ctx.agentDiscountCommission), 1),
                    _hoisted_5
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2))
        : _createCommentVNode("", true),
      (
          _ctx.showInsuranceThresholdBanner &&
            _ctx.protectionPacking.showTresholdProtection
        )
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_Icons, {
                name: "warning-circle",
                class: "w-5"
              }),
              _createVNode("div", _hoisted_8, [
                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("bookingV4.sender.phone.error.fraud.tresholdProtection")), 1),
                _createVNode("span", _hoisted_10, _toDisplayString(_ctx.formatPrice(_ctx.insuranceBasic.insuranceBasicStartFrom)) + ". ", 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("bookingV4.protection.itemPrice.title")), 1),
      _createVNode(_component_LpInput, {
        "data-testid": "txn-booking-input-harga-barang",
        prefix: _ctx.currencyPrefix,
        prefixPadding: "px-4 pl-2 py-2.5",
        modelValue: _ctx.itemPriceDisplay,
        placeholder: _ctx.$t('bookingV4.protection.itemPrice.placeholder'),
        error: !!_ctx.itemPriceError,
        "error-caption": _ctx.itemPriceError,
        format: _ctx.formatItemPrice,
        disabled: _ctx.disabledGoodsPrice,
        onChange: _ctx.onItemPriceInput,
        onBlur: _ctx.onItemPriceBlur
      }, null, 8, ["prefix", "modelValue", "placeholder", "error", "error-caption", "format", "disabled", "onChange", "onBlur"]),
      _hoisted_13
    ]),
    (_ctx.showCodAmountField)
      ? (_openBlock(), _createBlock(_component_DataWrapper, {
          key: 0,
          fontSize: 14,
          label: _ctx.$t('bookingV4.protection.codAmount.title'),
          tooltipDescription: 
        _ctx.$t('bookingV4.protection.codAmount.tooltipDescription')
      ,
          optional: "",
          isDarkMode: ""
        }, {
          default: _withId(() => [
            _createVNode(_component_LpInput, {
              "data-testid": "txn-booking-input-tagihan-cod",
              prefix: _ctx.currencyPrefix,
              modelValue: _ctx.codAmountDisplay,
              placeholder: _ctx.$t('bookingV4.protection.codAmount.placeholder'),
              format: _ctx.formatItemPrice,
              disabled: _ctx.disabledCodAmount,
              onChange: _ctx.onCodAmountInput,
              onBlur: _ctx.onCodAmountBlur
            }, null, 8, ["prefix", "modelValue", "placeholder", "format", "disabled", "onChange", "onBlur"])
          ]),
          _: 1
        }, 8, ["label", "tooltipDescription"]))
      : _createCommentVNode("", true)
  ]))
})